import { render, staticRenderFns } from "./edit-supplier.vue?vue&type=template&id=474c9af6&scoped=true&"
import script from "./edit-supplier.vue?vue&type=script&lang=ts&"
export * from "./edit-supplier.vue?vue&type=script&lang=ts&"
import style0 from "./edit-supplier.vue?vue&type=style&index=0&id=474c9af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c9af6",
  null
  
)

component.options.__file = "edit-supplier.vue"
export default component.exports